<template>
    <div>
        <div class=" max-w-5xl mx-auto mt-10">
            <osv-new-password />
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>